import { SocketIoConfig } from "ngx-socket-io";

/**
 * プロジェクトタイトル
 */
export const TITLE = {
  // タイトルバー
  TITLE_BAR: "福岡県中高生と乳幼児のふれあい体験マッチングシステム　コドモミライコネクト",
  // タイトルフッダー
  TITLE_FOOTER: "",
  // 開設日
  OPENING_DATE:
    "Copyright © 2020 Cabinet Office, Government Of Japan. All Rights Reserved.",
};

/**
 * 本番ドメイン
 */
export const PROD_DOMAIN = "kodomo-fureai.pref.fukuoka.lg.jp";

/**
 * domain test
 */
export const TEST_DOMAIN = "d2vonqoofmurh.cloudfront.net";

/**
 * domain stagging
 */
 export const STAGING_DOMAIN = "d112pdjy5u3r7.cloudfront.net";

/**
 * domain demo
 */
 export const DEMO_DOMAIN = "d39uh0riulgdzk.cloudfront.net";

/**
 * domain trial
 */
 export const TRIAL_DOMAIN = "d5heixpnwc24y.cloudfront.net";

/**
 * 非ログイン用APIキー
 */
// export const API_KEY = "e33f5421bc3645be8a0dece6689fac2f";


/**
 * 国際化（i18n）設定
 */
export const environment_i18n = {
  production: false,
  defaultLang: "ja",
};

/**
 * セッションキー
 */
export const SESSION_KEY = {
  // ログインユーザ情報
  loginUserInformation: "loginUserInformation",

  // TODO ログアウト時のメッセージコード格納に使用　※auth0が間に入り、いいパラメータ受け渡し方法が見つかるまで使用
  // ログインアウト時メッセージコード
  loginOutMessageCode: "loginOutMessageCode",
};

export const CLOSE_LOGIC1_DEV_DOMAIN =
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/";
export const CLOSE_LOGIC2_DEV_DOMAIN =
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/";
export const OPEN_LOGIC1_DEV_DOMAIN =
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/";
export const OPEN_LOGIC2_DEV_DOMAIN =
  "https://q5nmvdwxkj.execute-api.ap-northeast-1.amazonaws.com/dev/";

export const OPEN_LOGIC1_TEST_DOMAIN =
"https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/";
export const CLOSE_LOGIC1_TEST_DOMAIN =
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/";
export const CLOSE_LOGIC2_TEST_DOMAIN =
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/";

export const OPEN_LOGIC1_STAGING_DOMAIN =
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/";
export const CLOSE_LOGIC1_STAGING_DOMAIN =
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/";
export const CLOSE_LOGIC2_STAGING_DOMAIN =
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/";

export const OPEN_LOGIC1_PROD_DOMAIN =
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/";
export const CLOSE_LOGIC1_PROD_DOMAIN =
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/";
export const CLOSE_LOGIC2_PROD_DOMAIN =
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/";

export const OPEN_LOGIC1_DEMO_DOMAIN =
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/";
export const CLOSE_LOGIC1_DEMO_DOMAIN =
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/";
export const CLOSE_LOGIC2_DEMO_DOMAIN =
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/";

export const OPEN_LOGIC1_TRIAL_DOMAIN =
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/";
export const CLOSE_LOGIC1_TRIAL_DOMAIN =
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/";
export const CLOSE_LOGIC2_TRIAL_DOMAIN =
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/";

export const socketIoConfig: SocketIoConfig = {
  // url: "http://localhost:8080",
  url: "https://54.95.104.20:8080",
  options: {},
};
